import React from 'react';
import { MessageCompositionStudio } from '../useMessageCompositionStudio';
import EmailDelivery from '../delivery/EmailDelivery';
import SlackDelivery from '../delivery/SlackDelivery';
import WhatsAppDelivery from '../delivery/WhatsAppDelivery';

const DeliverySection: React.FC<{ studio: MessageCompositionStudio }> = ({ studio }) => {
    const { meta, envelopeTemplate, readOnly, updateChannelConfig } = studio;
    if (!meta) return null;
    const config = meta.channelConfig;

    if (config.kind === 'EMAIL') {
        return (
            <EmailDelivery
                config={config}
                envelopeTemplate={envelopeTemplate}
                disabled={readOnly}
                onConfigChange={updateChannelConfig}
                onEnvelopeChange={(envelope) => envelopeTemplate && studio.updateTemplate(envelopeTemplate.id, { envelope })}
                onCreateEnvelope={studio.createEnvelope}
            />
        );
    }
    if (config.kind === 'INTERNAL_MESSAGE') {
        return <SlackDelivery config={config} disabled={readOnly} onChange={updateChannelConfig} />;
    }
    return <WhatsAppDelivery config={config} disabled={readOnly} onChange={updateChannelConfig} />;
};

export default DeliverySection;
